import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { Chip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { TokenPrice } from "@/components/price/TokenPrice";
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment";
export const CollectionFloorPriceChipFragment = graphql(`
    fragment CollectionFloorPriceChip on Collection {
      floorPrice {
        pricePerItem {
          ...TokenPrice
        }
      }
    }
  `, [TokenPriceFragment]);
export function CollectionFloorPriceChip(t0) {
  const $ = _c(13);
  let collectionKey;
  let rest;
  if ($[0] !== t0) {
    ({
      collection: collectionKey,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = collectionKey;
    $[2] = rest;
  } else {
    collectionKey = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== collectionKey) {
    t1 = readFragment(CollectionFloorPriceChipFragment, collectionKey);
    $[3] = collectionKey;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const collection = t1;
  const t = useTranslations("CollectionFloorPriceChip");
  if (!collection.floorPrice?.pricePerItem) {
    return;
  }
  let t2;
  if ($[5] !== collection.floorPrice?.pricePerItem || $[6] !== t) {
    let t3;
    if ($[8] !== collection.floorPrice?.pricePerItem) {
      t3 = () => <TokenPrice price={collection.floorPrice?.pricePerItem} />;
      $[8] = collection.floorPrice?.pricePerItem;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = t.rich("floor", {
      price: t3
    });
    $[5] = collection.floorPrice?.pricePerItem;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[10] !== rest || $[11] !== t2) {
    t3 = <Chip className="gap-1.5" {...rest}>{t2}</Chip>;
    $[10] = rest;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}